export const NAME = 'assignments';
export const LEVEL_ONE = 'AssignmentsComponentReducer';
